<app-journey-metadata-dialog (onSave)="onNew($event)" (onCancel)="onBack()"></app-journey-metadata-dialog>

@if (showDialog) {
  <div class="dialog-background">
    <div class="dialog-content">
      @if (message != null) {
        <p>{{message}}</p>
      }
      <button (click)="showDialog=false" type="button"
        class="btn btn-default">OK
      </button>
    </div>
  </div>
}
